const campaignsObj = {
  vestillion: {
    name: "The Vestillion Brand",
    code: "vestillion",
  },
  corral: {
    name: "The Corral",
    code: "corral",
  },
  precipice: {
    name: "Precipice",
    code: "precipice",
  },
  all: {
    name: "All Campaigns",
    code: "all",
  },
};

export const allCampaignLocations = [
  "/login",
  "/",
  "/settings",
  "/settings/profile",
];

export default campaignsObj;
